import { signOut } from 'firebase/auth';
import { auth } from '../../lib/firebase';

type OnFn = (el: any, ev: string, fn: any) => void;

/**
 * When a user is logged in, replace the static "login / sign up" nav (from the Claude Design
 * markup, which is auth-unaware) with a proper account menu: one avatar+name button that opens
 * a dropdown showing the user's name/email plus Dashboard and Logout actions.
 * All listeners register through `on` so the caller cleans them up on unmount.
 */
export function setupAccountNav(R: HTMLElement, user: any, navigate: (p: string) => void, on: OnFn) {
  if (!user) return;
  const name: string = user.displayName || user.username || (user.email || '').split('@')[0] || 'บัญชีของฉัน';
  const email: string = user.email || '';
  const initial = (name || 'U').charAt(0).toUpperCase();

  const doLogout = async () => {
    try { localStorage.removeItem('auth_user_cache'); await signOut(auth); } catch { /* ignore */ }
    navigate('/');
  };

  // desktop: hide the plain "เข้าสู่ระบบ" nav link (account button replaces it)
  R.querySelectorAll<HTMLElement>('.dtop-nav a').forEach(a => {
    if ((a.textContent || '').trim() === 'เข้าสู่ระบบ') a.style.display = 'none';
  });

  // reuse the "สมัครใช้งาน" CTA as the account button
  const acct = Array.from(R.querySelectorAll<HTMLAnchorElement>('a')).find(a => (a.textContent || '').trim().indexOf('สมัครใช้งาน') === 0);
  if (acct) {
    acct.setAttribute('href', '#');
    acct.style.gap = '8px';
    acct.innerHTML =
      '<span style="width:22px; height:22px; border-radius:999px; background:rgba(255,255,255,0.28); display:inline-flex; align-items:center; justify-content:center; font-size:12px; font-weight:700">' + initial + '</span>' +
      '<span style="max-width:130px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap">' + name + '</span>' +
      '<span style="font-size:10px; opacity:0.85">▾</span>';

    const parent = acct.parentElement as HTMLElement; // header inner (position:relative)
    const menu = document.createElement('div');
    menu.style.cssText = "position:absolute; top:calc(100% + 6px); right:clamp(16px,4.5vw,48px); min-width:230px; background:#fff; border:1px solid oklch(0.9 0.02 175); border-radius:16px; box-shadow:0 26px 50px -22px rgba(14,58,64,0.4); padding:8px; display:none; z-index:80; font-family:'IBM Plex Sans Thai',system-ui,sans-serif";
    menu.innerHTML =
      '<div style="padding:10px 12px; border-bottom:1px solid oklch(0.94 0.01 180); margin-bottom:6px"><div style="font-family:\'Anuphan\',sans-serif; font-weight:600; font-size:14px; color:#0E3A40; overflow:hidden; text-overflow:ellipsis; white-space:nowrap">' + name + '</div><div style="font-size:12px; color:oklch(0.55 0.02 195); overflow:hidden; text-overflow:ellipsis; white-space:nowrap">' + email + '</div></div>' +
      '<a href="#" data-acct="dash" style="display:flex; align-items:center; gap:9px; padding:11px 12px; border-radius:11px; font-size:14px; color:#0E3A40; text-decoration:none">แดชบอร์ดของฉัน</a>' +
      '<a href="#" data-acct="logout" style="display:flex; align-items:center; gap:9px; padding:11px 12px; border-radius:11px; font-size:14px; color:#C0392B; text-decoration:none">ออกจากระบบ</a>';
    parent.appendChild(menu);

    on(acct, 'click', (e: Event) => { e.preventDefault(); menu.style.display = menu.style.display === 'none' ? 'block' : 'none'; });
    on(menu.querySelector('[data-acct="dash"]'), 'click', (e: Event) => { e.preventDefault(); menu.style.display = 'none'; navigate('/dashboard'); });
    on(menu.querySelector('[data-acct="logout"]'), 'click', (e: Event) => { e.preventDefault(); menu.style.display = 'none'; doLogout(); });
    on(document, 'click', (e: Event) => { const t = e.target as Node; if (!acct.contains(t) && !menu.contains(t)) menu.style.display = 'none'; });
  }

  // mobile menu: "เข้าสู่ระบบ" -> "แดชบอร์ด", plus a logout item
  const mm = R.querySelector<HTMLElement>('#mobileMenu');
  if (mm) {
    const mLogin = Array.from(mm.querySelectorAll<HTMLAnchorElement>('a')).find(a => (a.textContent || '').trim() === 'เข้าสู่ระบบ');
    if (mLogin) {
      mLogin.textContent = 'แดชบอร์ดของฉัน';
      on(mLogin, 'click', (e: Event) => { e.preventDefault(); navigate('/dashboard'); });
      const lo = document.createElement('a');
      lo.href = '#';
      lo.setAttribute('style', (mLogin.getAttribute('style') || '') + '; color:#C0392B');
      lo.textContent = 'ออกจากระบบ';
      mm.appendChild(lo);
      on(lo, 'click', (e: Event) => { e.preventDefault(); doLogout(); });
    }
  }
}
